import { faUndo } from "@fortawesome/free-solid-svg-icons";
import UnForm from "../../../../../Components/Form";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../../Context/Historico";
import { AtualizarAtendimentoController } from "../../../../../Controllers/Geral/Atendimentos/AtendimentosController";
import { ListarTipoRecorrenciaController } from "../../../../../Controllers/Geral/GestaoDeCadastros/TipoRecorrencia/TipoRecorrenciaController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";

interface IMarcarAtendimentoComoRecorrenteProps {
    ID_CASO: number;
    setShow(show: boolean): void;
}

interface IMarcarAtendimentoComoRecorrenteFormData {
    ID_TIPO_RECORRENCIA: number;
}

export default function MarcarAtendimentoComoRecorrente(
    props: IMarcarAtendimentoComoRecorrenteProps
) {
    const { updateAtendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const { loading: atualizando, execute } = useAsyncCallback(
        AtualizarAtendimentoController
    );

    function handleMarcarAtendimentoComoRecorrenteFormSubmit(
        formData: IMarcarAtendimentoComoRecorrenteFormData
    ) {
        execute(props.ID_CASO, {
            ID_TIPO_RECORRENCIA: formData.ID_TIPO_RECORRENCIA,
        }).then(() => {
            updateAtendimento();
            ReloadHistorico?.();
            props.setShow(false);
        });
    }

    return (
        <UnForm handleSubmit={handleMarcarAtendimentoComoRecorrenteFormSubmit}>
            <UnForm.LazySelect
                controller={ListarTipoRecorrenciaController}
                getDS={(tr) => tr.DS_TIPO_RECORRENCIA}
                getKeyValue={(tr) => tr.ID_TIPO_RECORRENCIA}
                name="ID_TIPO_RECORRENCIA"
                label="Tipo de Recorrência"
                registerOptions={{
                    required: "Insira o tipo de recorrência",
                }}
                wrapperClassName="col-12"
            >
                <option></option>
            </UnForm.LazySelect>
            <UnForm.SubmitButton
                loading={atualizando}
                loadingSize="sm"
                color="success"
                icon={faUndo}
                wrapperClassName="w-100 mt-5"
                className="w-100"
            >
                Marcar como Recorrente
            </UnForm.SubmitButton>
        </UnForm>
    );
}
